import { Route } from '@angular/router';
import { MainLayoutComponent } from './core/layout/main-layout/main-layout.component';
import { isAuthenticatedGuard } from './shared/guard/is-authenticated.guard';

export const appRoutes: Route[] = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./page/auth/auth.routes').then(m => m.authRoutes),
  },
  {
    path: 'privacy-policy',
    loadComponent: () =>
      import('./page/legal/view/privacy-policy/privacy-policy.component').then(
        m => m.PrivacyPolicyComponent
      ),
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [isAuthenticatedGuard()],
    children: [
      {
        path: '',
        redirectTo: 'my-patients',
        pathMatch: 'full',
      },
      {
        path: 'my-patients',
        loadChildren: () =>
          import('./page/my-patient/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()],
      },
      {
        path: 'meetings',
        loadChildren: () =>
          import('./page/meetings/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()],
      },
      {
        path: 'requests',
        loadChildren: () =>
          import('./page/requests/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()],
      },
      {
        path: 'account',
        loadChildren: () =>
          import('./page/settings/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()],
      },
      {
        path: 'contact-admin',
        loadChildren: () =>
          import('./page/contact-admin/routes').then(m => m.routes),
        canActivate: [isAuthenticatedGuard()],
      },
    ],
  },
  {
    path: '**',
    redirectTo: '',
  }
];
